import React from "react";
import { navigate } from "../../../services";
import { connect } from "react-redux";
import styled from "styled-components";
import { THEME_LOW } from "../../../reducers/reader";
import { EVT_KEYDOWN, KEY_LEFT_ARROW, KEY_RIGHT_ARROW } from "../../../lib";
import { pageUrl, device } from "../../../helpers";
import { prevWhite, prevBlack, nextWhite, nextBlack } from "../../../images";

import { COLORS } from "../BgColor";
import { Link } from "react-router-dom";
import { ReaderDoc } from "../PageContents/index";
import { AppState } from "../../../store";

const Container = styled.div<{
    theme: string;
}>`
    position: fixed;
    z-index: 30;
    display: flex;
    justify-content: space-between;
    align-items: center;
    right: 0;
    top: 0;
    width: 100%;
    height: 12vh;
    padding-bottom: 2vh;
    color: ${(p) => COLORS[p.theme]["color"]};
    background-color: ${(p) => COLORS[p.theme]["bgColor"]};

    @media ${device.phone} {
        height: 13vh;
        padding-bottom: 2vh;
    }
`;

const Title = styled.div`
    user-select: none;
    font-size: 24px;
    font-weight: 700;
    white-space: nowrap;
    text-align: center;
    font-family: urdu, QuranFont, sans-serif;

    [lang="ar"] {
        font-size: 14px;
    }

    @media ${device.phone} {
        margin-top: 0;
        width: 100%;
        font-size: 18px;
    }
`;

const EmptyNav = styled.div<{
    prev?: boolean;
}>`
    width: 20%;
    height: 18px;
    margin: ${(p) => (p.prev ? "0 40px 0 0" : "0 0 0 40px")};
    background-color: transparent;

    @media ${device.phone} {
        min-width: 12px;
        min-height: 18px;
        margin: ${(p) => (p.prev ? "0 15px 0 0" : "0 0 0 15px")};
    }
`;

const Icon = styled.img`
    width: 12px;
    height: 20px;
`;

const Nav = styled(Link)`
    user-select: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 20%;
    text-decoration: none;
    font-family: Cairo, QuranFont, urdu;

    [lang="ar"] {
        font-size: 15px;
    }
`;
const Prev = styled(Nav)<{ theme: string }>`
    justify-content: flex-start;
    color: ${(p) => COLORS[p.theme]["color"]};
    margin-right: 40px;

    img {
        margin-left: 10px;
    }

    @media ${device.phone} {
        margin-right: 15px;

        img {
            margin-left: 0;
        }
    }
`;
const Next = styled(Nav)<{ theme: string }>`
    justify-content: flex-end;
    color: ${(p) => COLORS[p.theme]["color"]};
    margin-left: 40px;

    img {
        margin-right: 10px;
    }

    @media ${device.phone} {
        margin-left: 15px;

        img {
            margin-right: 0;
        }
    }
`;

const NavLabel = styled.div`
    display: block;
    font-size: 20px;
    font-weight: 700;
    font-family: urdu, QuranFont, sans-serif;

    @media ${device.phone} {
        display: none;
    }
`;

const mapState = ({ reader }: AppState) => ({
    // @ts-ignore
    theme: reader.get("theme") as string,
});
type StateProps = ReturnType<typeof mapState>;
type OwnProps = {
    doc_id: number;
    page_id: number;
    theme: string;
    doc: ReaderDoc;
};
type Props = StateProps & OwnProps;
class Toolbar extends React.Component<Props> {
    componentDidMount() {
        window.addEventListener(EVT_KEYDOWN, this.onShortcut);
    }

    componentWillUnmount() {
        window.removeEventListener(EVT_KEYDOWN, this.onShortcut);
    }

    onShortcut = (evt: KeyboardEvent) => {
        if (evt.key === KEY_RIGHT_ARROW) {
            const r = this.prev();
            if (r) {
                navigate.to(r.url);
            }
        } else if (evt.key === KEY_LEFT_ARROW) {
            const r = this.next();
            if (r) {
                navigate.to(r.url);
            }
        }
    };

    prev() {
        const { doc, page_id } = this.props;
        const { pages } = doc;
        const current = pages.filter((p) => p.id === page_id)[0];
        const i = pages.indexOf(current) - 1;

        if (!page_id || i < 0) {
            return null;
        }

        const page = pages[i];
        return {
            page,
            url: pageUrl(doc, page),
        };
    }

    next() {
        const { doc, page_id } = this.props;
        const { pages } = doc;
        const current = pages.filter((p) => p.id === page_id)[0];
        let i =
            typeof current === "undefined" && pages.length > 0
                ? 1
                : pages.indexOf(current) + 1;

        if (i >= pages.length) {
            return null;
        }

        const page = pages[i];
        return {
            page,
            url: pageUrl(doc, page),
        };
    }

    prevNav() {
        const r = this.prev();
        if (!r) {
            return <EmptyNav prev={true} />;
        }

        const { page, url } = r;

        return (
            <Prev to={url} theme={this.props.theme}>
                <Icon
                    alt="پچھلا"
                    src={this.props.theme === THEME_LOW ? prevWhite : prevBlack}
                />
                <NavLabel>{page.name}</NavLabel>
            </Prev>
        );
    }

    nextNav() {
        const r = this.next();
        if (!r) {
            return <EmptyNav prev={false} />;
        }

        const { page, url } = r;

        return (
            <Next to={url} theme={this.props.theme}>
                <NavLabel>{page.name}</NavLabel>
                <Icon
                    alt="اگلا"
                    src={this.props.theme === THEME_LOW ? nextWhite : nextBlack}
                />
            </Next>
        );
    }

    pageId() {
        const {
            doc: { pages },
            page_id,
        } = this.props;
        return page_id || pages[0]["id"];
    }

    pageTitle() {
        const id = this.pageId();
        return this.props.doc.pages.filter((o) => o.id === id)[0].name;
    }

    render() {
        const { theme } = this.props;

        return (
            <Container theme={theme}>
                {this.prevNav()}
                <Title theme={theme}>{this.pageTitle()}</Title>
                {this.nextNav()}
            </Container>
        );
    }
}

export default connect(mapState)(Toolbar);
